document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('variant-selects, variant-radios').forEach(function (variantPicker) {
    variantPicker.addEventListener('change', function () {
      var form = variantPicker.closest('form');
      if (!form) return;

      var variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) return;

      var variantId = variantIdInput.value;
      var productHandle = variantPicker.dataset.url || window.location.pathname;

      fetch('/products/' + productHandle.split('/products/')[1] + '.js')
        .then(function (res) { return res.json(); })
        .then(function (product) {
          var variant = product.variants.find(function (v) { return v.id == variantId; });
          if (!variant) return;

          document.querySelectorAll('.js-product-sku').forEach(function (el) {
            var template = el.dataset.skuText || '{SKU}';
            el.textContent = template.replace('{SKU}', variant.sku || '');
          });
        });
    });
  });
});